import React, { useEffect, useState } from "react";

const OvdSDK = () => {
  const [token, setToken] = useState("");
  const [sdkData, setSdkData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [clientKey, setClientKey] = useState("");
  const [requestId, setRequestId] = useState("");
  const [scriptUrl, setScriptUrl] = useState("https://d2ex1ser8dn35u.cloudfront.net/ovd_uat_script.js");

  const handleSDKData = (data) => {
    setSdkData(data);
  };

  const handleGetTokenAndSDKInit = () => {
    if (!clientKey || !scriptUrl) {
      alert("Please provide both the Client Key and Script URL.");
      return;
    }

    setLoading(true);

    const apiUrl = `https://dgxnurl2a2.execute-api.ap-south-1.amazonaws.com/v1/ovd_token_generation`;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "clientname": clientKey,
        "requestid": requestId
      }),
    };

    fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setToken(data.data.token);
        window.AinxtSDK.Initialize(
          data.data.token,
          handleSDKData,
        );
      })
      .catch((error) => {
        console.error("Error fetching token:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (scriptUrl) {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;

      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, [scriptUrl]); // Dependency on scriptUrl

  return (
    <div className="text-center">
      <h1 style={{ color: "white" }} className="text-4xl font-bold mb-8">
         OVD SDK Test
      </h1>

      <div className="mb-4">
        <input
          type="text"
          placeholder="Enter Client Key"
          value={clientKey}
          onChange={(e) => setClientKey(e.target.value)}
          className="form-control mb-2"
          style={{
            padding: "10px",
            width: "300px",
            margin: "10px auto",
            display: "block",
            borderRadius: "5px",
          }}
        />
        <input
          type="text"
          placeholder="Enter Request id"
          value={requestId}
          onChange={(e) => setRequestId(e.target.value)}
          className="form-control mb-2"
          style={{
            padding: "10px",
            width: "300px",
            margin: "10px auto",
            display: "block",
            borderRadius: "5px",
          }}
        />
        <input
          type="text"
          placeholder="Enter Script URL"
          value={scriptUrl}
          onChange={(e) => setScriptUrl(e.target.value)}
          className="form-control"
          style={{
            padding: "10px",
            // width: "300px",
            margin: "10px auto",
            display: "block",
            borderRadius: "5px",
          }}
        />
      </div>


      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        onClick={handleGetTokenAndSDKInit}
        disabled={loading}
        style={{
          background: "linear-gradient(90deg, #5e24a0, #9e6dd5)",
        }}
      >
        {loading ? "Loading..." : "Get Token & Initialize AinxtSDK"}
      </button>

      {sdkData && (
        <div className="mt-4 ">
          <h2 style={{ color: "black" }} className="text-xl font-bold mb-2">
            Data from SDK:
          </h2>
          <pre style={{ color: "black" }} className="whitespace-pre-wrap">
            {JSON.stringify(sdkData, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default OvdSDK;